import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { ProgramBuilderMainService } from './program-builder-main.service';
import { CreateCategoryComponent } from './components/create-category/create-category.component';
import { CreateProgramComponent } from './components/create-program/create-program.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { EditProgramComponent } from './components/edit-program/edit-program.component';
import { ProgramPageService } from '../../../learning-center/components/program-page/program-page.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EditProgramNewBuilderComponent } from './components/edit-program-new-builder/edit-program-new-builder.component';
import { PostHogService } from 'src/app/shared/services/posthog.service';

@Component({
	selector: 'app-program-builder-main',
	templateUrl: './program-builder-main.component.html',
	styleUrls: ['./program-builder-main.component.scss'],
	animations: [
		trigger('widthGrow', [
			state('closed', style({
				width: 0,
			})),
			state('open', style({
				width: 760,
				maxWidth: '100%'
			})),
			transition('* => *', animate(150))
		]),
		trigger('widthGrowOpacity', [
			state('closed', style({
				width: 0,
			})),
			state('open', style({
				width: 10000,
			})),
			// transition('* => *', animate(10))
		]),

	]
})
export class ProgramBuilderMainComponent implements OnInit {
	@ViewChild('cardElement') cardElement!: ElementRef;
	@Input() headerTitle = '';
	state = "closed";
	categories: any = [];
	programs: any = [];
	programDetails: any;
	blockLoader: string = "blockLoader";

	ngAfterViewInit() {
		this.calculateCardHeight();
	}

	constructor(
		private router: Router,
		public dialog: MatDialog,
		private _programBuilderMainService: ProgramBuilderMainService,
		private spinner: NgxSpinnerService,
		private programPageService: ProgramPageService,
		private snackbar: MatSnackBar,
		private postHogService: PostHogService
	) { }

	ngOnInit(): void {
		this.getCategories();
		this.calculateCardHeight();
	}

	async launchProgram(program: any) {
		if (program.localizedDate) {
			delete program["localizedDate"];
		}

		if (!program.programMenuCompleted) {
			this.snackbar.open("This program is incomplete and cannot be enrolled in.", "OK");
			return;
		}

		const userId = localStorage.getItem('userId');
		const progressId = userId + "_" + program.id;

		if (!program.isUserEnrolled) {
			await this.spinner.show("blockLoader");
			delete program['isUserEnrolled'];
			if (program['progress']) {
				delete program['progress'];
			}
			await this.programPageService.saveLaunchData(program);
			await this.spinner.hide("blockLoader");
		}

		// Capture PostHog event when program is launched
		const userEmail = localStorage.getItem('username');
		const role = localStorage.getItem('roleId');

		this.postHogService.capture('Launch Program', {
			'User email': userEmail,
			'device_type': 'Web',
			'role': role,
			'program name': program.name
		});

		this.router.navigate(['programs'], {
			state: {
				progressId
			}
		});
	}

	changeState(programDetails: any): void {
		// console.log(programDetails);
		this.programDetails = programDetails;
		if (programDetails === 'cross') {
			this.programDetails = '';
		}
		(this.state == "closed") ? this.state = "open" : this.state = "closed";
		(this.state == "closed") ? this.state = "open" : this.state = "closed";
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});

		if (this.state == "closed") {
			this.state = "open";
			document.body.style.overflow = 'hidden';
		} else {
			this.state = "closed";
			document.body.style.overflow = 'auto';
		}
	}

	createProgram(data: any = null) {
		const dialogRef = this.dialog.open(CreateProgramComponent, {
			data,
			minWidth: '30%',
			panelClass: "create-program-modal"
		});

		dialogRef.afterClosed().subscribe((result: any) => {
			// console.log(`Dialog result: ${result}`);
			if (result && result.created) {
				this.snackbar.open("New Program created", "OK", {
					duration: 3000
				});

				try {
					const catIndex = this.categories.findIndex((cat: any) => cat.id === result.data.category.id);

					if (catIndex === -1) {
						throw new Error(`Category with ID ${result.data.category.id} not found.`);
					}

					const catProgramIndex = this.categories[catIndex].programs.findIndex(
						(prg: any) => prg.id === result.data.id
					);

					if (catProgramIndex === -1) {
						throw new Error(`Program with ID ${result.data.id} not found in category ${this.categories[catIndex].name}.`);
					}

					this.editProgramNewBuilder(result.data, catIndex, catProgramIndex);
				} catch (error: any) {
					console.error('Error:', error.message);
					this.snackbar.open(error.message, "OK", {
						duration: 3000
					});
				}
			}
		});
	}

	getCategories() {
		// console.log('In organization')
		this._programBuilderMainService.getCategories().subscribe((data: any) => {
			this.categories = data;
			//   console.log('---------', this.categories);
			this.getPrograms();
		});
	}

	createCategory(data: any = null) {
		let dialogRef: any;
		const dataClone = JSON.parse(JSON.stringify(data))
		if (data) {
			dialogRef = this.dialog.open(CreateCategoryComponent, {
				data: dataClone,
				disableClose: true,
				// data: {
				//   id: data.id,
				//   name: data.name,
				//   subCategories: data.subCategories,
				//   visible: data.visible
				// },
				panelClass: "create-category-modal"
			});
		} else {
			dialogRef = this.dialog.open(CreateCategoryComponent, {
				data: {
					id: '',
					name: '',
					subCategories: [],
					visible: true,
				},
				disableClose: true,
				panelClass: "create-category-modal"
			});
		}


		dialogRef.afterClosed().subscribe((result: any) => {
			this.spinner.show();
			data = result;
			// console.log(`Dialog result: ${result}`);
			//   console.log('this.categories', this.categories);
			this.spinner.hide();
		});
	}

	getPrograms() {
		this._programBuilderMainService.getPrograms().subscribe(async data => {
			this.programs = data;
			for (let program of this.programs) {
				if ((!program.publishedAt || this.isEditedAfterPublication(program)) && program.updatedAt) {
					program.localizedDate = this.getLocalizedDate(program.updatedAt);
				} else if (program.publishedAt && !this.isEditedAfterPublication(program)) {
					program.localizedDate = this.getLocalizedDate(program.publishedAt);
				}
			}
			this.categories.forEach((cat: any, index: any) => {
				let program: any = [];

				this.programs.forEach((el: any) => {
					if (cat.name === el.category?.name) {
						program.push(el);
						this.categories[index].programs = program;
					}
				});
			});

			const userId = localStorage.getItem('userId');
			for (let cat of this.categories) {
				if (cat.programs) {
					for (let program of cat.programs) {
						program.isUserEnrolled = await this.programPageService.isUserEnrolled(program.id, userId);
						if (program.isUserEnrolled) {
							program.progress = await this.programPageService.getProgressInProgram(program.id, userId);
						}
					}
				}
			}
		})
	}

	getLocalizedDate(date: any) {
		if (date instanceof Date) { } else {
			date = new Date(date.seconds * 1000);
		}

		return date.toLocaleDateString(navigator.language, {
			year: '2-digit',
			month: '2-digit',
			day: '2-digit'
		});
	}

	editProgram(data: any) {
		const dialogRef = this.dialog.open(EditProgramComponent, {
			data,
		});

		dialogRef.afterClosed().subscribe((result: any) => {
			// console.log(`Dialog result: ${result}`);
			if (result && result.status === 'success') {
				data = result.data;
				this.snackbar.open("Program saved successfully!", "OK", {
					duration: 3000
				});
			} else {
				console.log('Program could not be saved!');
			}
		});
	}

	editProgramNewBuilder(data: any, catIndex: number, catProgramIndex: number) {
		const dialogRef = this.dialog.open(EditProgramNewBuilderComponent, {
			data: data,
			panelClass: 'edit-prg-new-builder',
			disableClose: true,
			hasBackdrop: false,
			autoFocus: true
		});

		dialogRef.afterClosed().subscribe((result: any) => {
			// console.log(`Dialog result: ${result}`);
			if (result && result.status === "success") {
				if (result.action === "save") {
					// Update the program data on program builder page.
					this.categories[catIndex].programs[catProgramIndex] = result.data;
					this.snackbar.open("Program saved successfully!", "OK", {
						duration: 3000
					});
				} else if (result.action === "delete") {
					// console.log("Program deleted.");
				}
			} else {
				// console.log('Program saving cancelled!');
			}
		});
	}

	calculateCardHeight(): number {
		if (this.cardElement) {
			const width = this.cardElement.nativeElement.offsetWidth;
			return width; // Use the width as the height value
		}
		return 0; // Default height value if element is not available
	}

	// isEditedAfterPublication(programDetails: any) {
	// 	const publishDate = new Date(programDetails.publishedAt.toDate()).getSeconds();
	// 	const editDate = new Date(programDetails.updatedAt.toDate()).getSeconds();

	// 	// grace period of 5 seconds to consider the case of some pending changes by autosave
	// 	if ((editDate - publishDate) >= 5) {
	// 		return true;
	// 	}
	// 	return false;
	// }

	isEditedAfterPublication(programDetails: any): boolean {

		// Check if publishedAt and updatedAt are in the expected format
		const publishDate = programDetails.publishedAt.seconds
			? new Date(programDetails.publishedAt.seconds * 1000 + programDetails.publishedAt.nanoseconds / 1000000)
			: new Date(programDetails.publishedAt);

		const editDate = programDetails.updatedAt.seconds
			? new Date(programDetails.updatedAt.seconds * 1000 + programDetails.updatedAt.nanoseconds / 1000000)
			: new Date(programDetails.updatedAt);

		const publishTime = publishDate.getTime();
		const editTime = editDate.getTime();

		// Grace period of 5 seconds
		if ((editTime - publishTime) >= 5000) {
			return true;
		}
		return false;
	}

	getDate(timestamp: any): Date | null {
		if (!timestamp) return null;

		// Check if timestamp has seconds and nanoseconds, then convert
		if (timestamp.seconds !== undefined && timestamp.nanoseconds !== undefined) {
			return new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
		}

		// If timestamp is already a Date object, return it directly
		if (timestamp instanceof Date) {
			return timestamp;
		}

		return null;  // Return null if none of the conditions match
	}
}
